import PropTypes from 'prop-types';

import Dialog from '@zenbusiness/zui/Dialog';

const APP_HEADER_HEIGHT = {
  xs: '52px',
  md: '68px'
};

function FullScreenDialog({ children, hideAppHeader, ...delegated }) {
  const slotProps = {
    backdrop: {
      sx: { display: 'none' }
    },
    root: {
      sx: !hideAppHeader && { top: APP_HEADER_HEIGHT }
    }
  };

  return (
    <Dialog disableEscapeKeyDown {...delegated} fullScreen slotProps={slotProps}>
      {children}
    </Dialog>
  );
}

FullScreenDialog.propTypes = {
  children: PropTypes.node.isRequired,
  hideAppHeader: PropTypes.bool
};

export default FullScreenDialog;
